import React from 'react'
import { palettes } from '@manychat/manyui'

import * as sharedStyles from 'common/builder/components/chart/FlowChart/nodes/shared/styles'
import { toPx } from 'common/builder/components/chart/utils/toPx'

const TEXT_SPACING = 10

export const emptyWrapper: React.CSSProperties = {
  display: 'flex',
  justifyContent: 'center',
  paddingTop: toPx(sharedStyles.Spacings.NORMAL),
  paddingBottom: toPx(sharedStyles.Spacings.NORMAL),
}

export const emptyText: React.CSSProperties = {
  ...sharedStyles.text,
  color: palettes.typography.disabledFG,
  textAlign: 'center',
}

export const titleText: React.CSSProperties = {
  ...sharedStyles.text,
  color: sharedStyles.Colors.BLACK,
  fontSize: toPx(sharedStyles.FontSizes.LARGE),
  lineHeight: 1,
  marginBottom: toPx(TEXT_SPACING),
}

export const text: React.CSSProperties = {
  ...sharedStyles.text,
  marginBottom: toPx(TEXT_SPACING),
}

export const footerText: React.CSSProperties = {
  ...sharedStyles.text,
  fontSize: toPx(sharedStyles.FontSizes.SMALL),
  lineHeight: 1.4,
  color: sharedStyles.Colors.SECONDARY,
}
